/**
 * @export
 * @param {any} router 路由
 * @param {any} store vuex store
 */
export default function LoadingConfig (router, store) {
  router.beforeEach(async (to, from, next) => {
    const { path, meta } = to
    store.dispatch('setFullScreen', meta.fullScreen)
    if (/^http/.test(path)) {
      const url = path.split('http')[1]
      window.location.href = `http${url}`
    } else {
      next()
    }
  })

  router.afterEach((to) => {
    const { meta } = to
    if (meta && meta.title) {
      document.title = meta.title
    }
    // if (NoAfterRouteIsLoading.indexOf(name) === -1 && to.meta.burialPoint) {
    //   setTimeout(() => {
    //     // store.commit('UPDATE_LOADING', { isLoading: false })
    //     NProgress.done()
    //   }, 10)
    // }
  })
}
